import { memo } from 'react';

import {
  Dialog,
  DialogHeader,
  DialogContent,
  DialogTitle,
  DialogFooter,
  DialogDescription,
  DialogClose
} from '@/shadcn/dialog';
import { Button } from '@/shadcn/button';
import { TestId } from '@/types/testId';

type Props = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  groupName: string;
  participantsStr: string;
  onSubmit: () => void;
};

/**  The modal to confirm the removal of a set of group members */
export const RemoveGroupMembersModal = memo(
  ({ isOpen, onOpenChange, groupName, participantsStr, onSubmit }: Props) => (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Remove from group</DialogTitle>
          <DialogDescription>
            Are you sure you want to remove <b>{participantsStr}</b> from the{' '}
            <b>{groupName}</b> group?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button
              variant="outline"
              data-testid={TestId.RemoveGroupMembersModal.CancelButton}
            >
              Cancel
            </Button>
          </DialogClose>
          <Button
            variant="destructive"
            type="submit"
            autoFocus
            onClick={onSubmit}
            disabled={!groupName}
            data-testid={TestId.RemoveGroupMembersModal.SubmitButton}
            aria-label={`Click to remove ${participantsStr} from group ${groupName}.`}
          >
            Remove
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
);
